import BaseModel from 'src/model/base.model';
import SubcategoryModel from 'src/model/subcategory.model';

class CategoryModel extends BaseModel {
  public category: ICategoryContent;
}

export interface ICategoryContent {
  id: number;
  name: string;
  frName: string;
  orderNumber: number;
  subcategories: SubcategoryModel[];
  menuState?: string;
}

export default CategoryModel;
